import { ActivityType } from '../../services/ReminderService';

export const ACTIVITY_LABELS: Partial<Record<ActivityType, string>> = {
  MANAGEMENT_SYSTEM: 'Yönetim Sistemi',
  MARKETING: 'Pazarlama',
  BUSINESS_PARTNER: 'İş Ortağı',
  DISCOVERY: 'Keşif',
  PROPOSAL: 'Teklif',
  CONTRACT: 'Sözleşme',
  PLAN: 'Planlama',
  LEGAL: 'Yasal Bildirim (İSG-Katip)',
  INSPECTION: 'Periyodik Kontrol Muayene',
  REPORT: 'Raporlama',
  ACCOUNTING: 'Muhasebe',
  FINANCE: 'Finans',
  PROCUREMENT: 'Satınalma',
  INFRASTRUCTURE: 'Altyapı',
  SOLUTION_PARTNER: 'Çözüm Ortağı',
  HUMAN_RESOURCES: 'İnsan Kıymetleri',
  COMPLAINT: 'Şikayet',
  OBJECTION: 'İtiraz',
  SATISFACTION: 'Memnuniyet',
  PREVENTIVE_ACTION: 'Düzeltici/Önleyici Faaliyet',
  OTHER: 'Diğer',
};

export const ACTIVITY_COLORS: Partial<Record<ActivityType, string>> = {
  MANAGEMENT_SYSTEM: 'geekblue',
  MARKETING: 'magenta',
  BUSINESS_PARTNER: 'cyan',
  DISCOVERY: 'gold',
  PROPOSAL: 'geekblue',
  CONTRACT: 'purple',
  PLAN: 'blue',
  LEGAL: 'red',
  INSPECTION: 'volcano',
  REPORT: 'cyan',
  ACCOUNTING: 'gold',
  FINANCE: 'orange',
  PROCUREMENT: 'lime',
  INFRASTRUCTURE: 'volcano',
  SOLUTION_PARTNER: 'blue',
  HUMAN_RESOURCES: 'purple',
  COMPLAINT: 'red',
  OBJECTION: 'volcano',
  SATISFACTION: 'green',
  PREVENTIVE_ACTION: 'orange',
  OTHER: 'default',
};
